'use strict';
var mainPageKidsPreload = ['$q', '$rootScope', 'SubjectsKids', 'StoriesKids', function ($q, $rootScope, SubjectsKids, StoriesKids) {
    var deferred = $q.defer();

    SubjectsKids.getPromise().then(function (subjects) {
        StoriesKids.getPromise().then(function (stories) {
            deferred.resolve();
        });
    });

    return deferred.promise;
}];

var generalPreload = ['$q', '$rootScope', 'Subjects', function ($q, $rootScope, Subjects) {
    var deferred = $q.defer();

    Subjects.getPromise().then(function (subjects) {
        deferred.resolve();
    });

    return deferred.promise;
}];

var indexPreload = ['$q', '$rootScope', 'Subjects', 'Stories', function ($q, $rootScope, Subjects, Stories ) {
    var deferred = $q.defer();

    Subjects.getPromise().then(function (subjects) {
        Stories.getPromise().then(function (stories) {
            deferred.resolve();
        });
    });

    return deferred.promise;
}];

var mapPreload = ['$q', '$rootScope', 'Subjects', 'Map', function ($q, $rootScope, Subjects, Map) {
    var deferred = $q.defer();

    Subjects.getPromise().then(function (subjects) {
        Map.getPromise().then(function (mapMarkers) {
            deferred.resolve();
        });
    });

    return deferred.promise;
}];

var advSearchPreload = ['$q', 'AdvSearch', function ($q, AdvSearch) {
    var deferred = $q.defer();
    AdvSearch.getPromise().then(function (advSearch) {
        deferred.resolve();
    })
    return deferred.promise;
}];

//Setting up route
module.exports = angular.module('agada.config', [])
    .config(['$stateProvider', '$locationProvider', '$urlRouterProvider', function ($stateProvider, $locationProvider, $urlRouterProvider) {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.when('/kids/', ['$state', function ($state) {
            $state.go('mainKids');
        }])
        $stateProvider
            .state("main", {
                url: "/",
                views: {
                    'header': {
                        controller: 'menuCtl',
                        template: require('../public/views/header.html'),
                    },
                    'content': {
                        controller: 'mainPageCtl',
                        template: require('../public/views/index.html'),
                    }
                },
                resolve: { deps: indexPreload },
            })
            .state("agadaKids", {
                url: "/kids/node/:agadaId",
                views: {
                    'header': {
                        controller: 'menuKidsCtl',
                        template: require('../public/kids/views/header.html')
                    },
                    'content': {
                        controller: 'agadaKidsCtl',
                        template: require('../public/kids/views/story.html')
                    }
                },
                resolve: { deps: mainPageKidsPreload },
                data: {
                    bodyClasses: 'pageMainKidsDiv',
                    contentClass: 'fullKidsDiv',
                }
            })
            .state("agada", {
                url: "/node/:agadaId",
                views: {
                    'header': {
                        controller: 'menuCtl',
                        template: require('../public/views/header.html')
                    },
                    'content': {
                        controller: 'agadaCtl',
                        template: require('../public/views/modals/story.html')
                    }
                },
                resolve: { deps: indexPreload },
                data: {
                    contentClass: 'fullDiv',
                }
            })

            .state("mainKids", {
                url: "/kids",
                views: {
                    'header': {
                        controller: 'menuKidsCtl',
                        template: require('../public/kids/views/header.html')
                    },
                    'content': {
                        controller: 'mainPageKidsCtl',
                        template: require('../public/kids/views/index.html')
                    }
                },
                resolve: { deps: mainPageKidsPreload },
                data: {
                    bodyClasses: 'pageMainKidsDiv',
                    contentClass: 'pageMainKidsDiv',
                }
            })
            .state("subject", {
                url: "/subject/:subjectId",
                views: {
                    'header': {
                        controller: 'menuCtl',
                        template: require('../public/views/header.html')
                    },
                    'content': {
                        controller: 'subjectCtl',
                        template: require('../public/views/subject.html')
                    }
                },
                resolve: { deps: generalPreload },
                reloadOnSearch: false
            })
            .state("aboutKids", {
                url: "/kids/about",
                views: {
                    'header': {
                        controller: 'menuKidsCtl',
                        template: require('../public/kids/views/header.html')
                    },
                    'content': {
                        template: require('../public/kids/views/about.html')
                    }
                },
                resolve: { deps: mainPageKidsPreload },
                data: {
                    bodyClasses: 'pageMainKidsDiv',
                    contentClass: 'otherPagesKidsDiv',
                }
            })
            .state("about", {
                url: "/about",
                views: {
                    'header': {
                        controller: 'menuCtl',
                        template: require('../public/views/header.html')
                    },
                    'content': {
                        template: require('../public/views/about.html')
                    }
                },
                resolve: { deps: generalPreload },
            })
            .state("advancedSearch", {
                url: "/advancedSearch",
                views: {
                    'header': {
                        controller: 'menuCtl',
                        template: require('../public/views/header.html')
                    },
                    'content': {
                        controller: 'advancedSearchCtl',
                        template: require('../public/views/advancedSearch.html')
                    }
                },
                resolve: { deps: generalPreload, search: advSearchPreload },
            })
            .state("advancedSearchKids", {
                url: "/kids/advancedSearch",
                views: {
                    'header': {
                        controller: 'menuKidsCtl',
                        template: require('../public/kids/views/header.html')
                    },
                    'content': {
                        controller: 'advancedSearchCtl',
                        template: require('../public/views/advancedSearch.html')
                    }
                },
                resolve: { deps: mainPageKidsPreload, search: advSearchPreload },
                data: {
                    bodyClasses: 'pageMainKidsDiv',
                    contentClass: 'otherPagesKidsDiv',
                }
            })

        .state("map", {
            url: "/map",
            views: {
                'header': {
                    controller: 'menuCtl',
                    template: require('../public/views/header.html')
                },
                'content': {
                    template: require('../public/views/map.html')
                }
            },
            resolve: { deps: mapPreload },
        })

        .state("search_results", {
            url: "/term_tid/:term_tid/person/:person/parasha/:parasha/time_of_year/:time_of_year/mikra_book/:mikra_book/midrash_source/:midrash_source/writer/:writer/kids_writer/:kids_writer/kids/:kids/adults/:adults/freeText/:freeText",
            views: {
                'header': {
                    controller: 'menuCtl',
                    template: require('../public/views/header.html')
                },
                'content': {
                    controller: 'searchResultsCtl',
                    template: require('../public/views/search_results.html')
                }
            },
            params: {
                type: null,
            },
            resolve: { deps: generalPreload, search: advSearchPreload },
        })
        .state("search_resultsKids", {
            url: "/kids/term_tid/:term_tid/person/:person/parasha/:parasha/time_of_year/:time_of_year/mikra_book/:mikra_book/midrash_source/:midrash_source/writer/:writer/kids_writer/:kids_writer/kids/:kids/adults/:adults/freeText/:freeText",
            views: {
                'header': {
                    controller: 'menuKidsCtl',
                    template: require('../public/kids/views/header.html')
                },
                'content': {
                    controller: 'searchResultsCtl',
                    template: require('../public/views/search_results.html')
                }
            },
            resolve: { deps: mainPageKidsPreload, search: advSearchPreload },
            data: {
                bodyClasses: 'pageMainKidsDiv',
                contentClass: 'otherPagesKidsDiv',
            },
            params: {
                type: null,
            },
        })
		.state("otherwiseKids", {
            url: '/kids/{path:.*}',
            views: {
                'header': {
                    controller: 'menuKidsCtl',
                    template: require('../public/kids/views/header.html')
                },
                'content': {
                    controller: 'menuKidsCtl',
                    template: require('../public/kids/views/404.html')
                }
            },
            resolve: { deps: mainPageKidsPreload },
            data: {
                bodyClasses: 'pageMainKidsDiv',
                contentClass: 'pageMainKidsDiv',
            }
        })
        .state("otherwise", {
            url: "*path",
            views: {
                'header': {
                    controller: 'menuCtl',
                    template: require('../public/views/header.html')
                },
                'content': {
                    controller: 'menuCtl',
                    template: require('../public/views/404.html')
                }
            },
            resolve: { deps: indexPreload },
        });
    }])
    .run(['$rootScope', '$state', '$stateParams', '$anchorScroll', '$location', function ($rootScope, $state, $stateParams, $anchorScroll, $location) {
        $rootScope.subjectLoaded = false;
        $rootScope.callNumber = 1;

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            $rootScope.previousStatus = fromState.name;

            (angular.isDefined(toState.data) && angular.isDefined(toState.data.bodyClasses)) ? $rootScope.bodyClasses = toState.data.bodyClasses : $rootScope.bodyClasses = 'pageMainDiv';
            (angular.isDefined(toState.data) && angular.isDefined(toState.data.contentClass)) ? $rootScope.contentClass = toState.data.contentClass : $rootScope.contentClass = 'pageMainDiv';
            $anchorScroll();
        });


        $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
            if (toState.name === $rootScope.previousState && (toState.name == 'agadaKids' || toState.name == 'agada') && !$rootScope.isMobile && !$(".fullKidsDiv").length > 0 && !$(".fullDiv").length > 0) {

                event.preventDefault();  // to Disable the event
                if (toState.name == 'agadaKids') { $rootScope.openStory(toParams.agadaId) }
                else if (toState.name == 'agada') { $rootScope.openStoryAdults(toParams.agadaId) }
                //alert("Back button Clicked");
            }
            else
                $rootScope.previousState = fromState.name;
        });
    }])
    .constant('NORMAL_STATE', 1)
    .constant('TABLET_STATE', 2)
    .constant('MOBILE_STATE', 3)
    .name;

require('./localValues.js')


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 108
// module chunks = 0